import * as React from "react";
import { useState, useMemo } from "react";
import styled from "styled-components";
import useHistory from "routing/useHistory";
import { isPermitted } from "util/PermissionsMixin";
import Routes from "routing/Routes";
import { Select, Icon } from "components/common";
import { BootstrapModalConfirm, MenuItem, Button, DeleteMenuItem } from "components/bootstrap";
import { useDeleteAsset, useGetCategories, useBulkAddCategories } from "security-app/hooks/useAssetsAPI";
import { useSelectedRows, useSelectedRowsDispatch } from "common/contexts";
import useCurrentUser from "hooks/useCurrentUser";
import { DropdownMenu } from "security-app/components/common";
const IconContainer = styled.div`
  width: 16px;
  display: inline-block;
  text-align: left;
`;
const StyledSelect = styled(Select)`
  margin-bottom: 1rem;
`;
const BulkActions = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [categoryValue, setCategoryValue] = useState(null);
  const { push } = useHistory();
  const selectedAssets = useSelectedRows();
  const selectedAssetsDispatch = useSelectedRowsDispatch();
  const { deleteAsset } = useDeleteAsset();
  const { bulkAddCategories } = useBulkAddCategories();
  const { categories } = useGetCategories();
  const categoryOptions = useMemo(
    () => categories.map((category) => ({
      value: category.category,
      label: category.category
    })),
    [categories]
  );
  const { permissions } = useCurrentUser();
  const canManageAssets = useMemo(() => isPermitted(permissions, "asset:edit"), [permissions]);
  const onAddCategory = () => {
    setShowAddCategoryModal(true);
  };
  const onDelete = () => {
    setShowDeleteModal(true);
  };
  const onSearch = () => {
    const assetIds = [];
    selectedAssets.map((asset) => assetIds.push(`associated_assets:${asset.id}`));
    push(Routes.search(`(${assetIds.join(" OR ")})`, { relative: 0 }));
  };
  const resetCategoryModalStates = () => {
    setShowAddCategoryModal(false);
    setCategoryValue(null);
  };
  const onConfirmAddCategories = async () => {
    const assetIds = [];
    selectedAssets.map((asset) => assetIds.push(asset.id));
    bulkAddCategories({ assetIds, categories: categoryValue });
    resetCategoryModalStates();
    selectedAssetsDispatch({ type: "clear" });
  };
  const onConfirmDelete = async () => {
    const deletes = selectedAssets.map((asset) => deleteAsset({ assetId: asset.id }));
    await Promise.all(deletes);
    setShowDeleteModal(false);
    selectedAssetsDispatch({ type: "clear" });
  };
  const clearSelection = (e) => {
    e.stopPropagation();
    selectedAssetsDispatch({ type: "clear" });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    DropdownMenu,
    {
      trigger: /* @__PURE__ */ React.createElement(Button, { bsSize: "small", disabled: selectedAssets.length < 1 }, /* @__PURE__ */ React.createElement(IconContainer, null, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_drop_down", size: "sm" })), "Bulk Actions ", selectedAssets.length > 0 ? selectedAssets.length : null, selectedAssets.length > 0 && /* @__PURE__ */ React.createElement(IconContainer, { onClick: clearSelection, style: { marginLeft: 10 } }, /* @__PURE__ */ React.createElement(Icon, { name: "close" })))
    },
    /* @__PURE__ */ React.createElement(MenuItem, { onClick: onSearch }, "Search for selected assets"),
    canManageAssets ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: onAddCategory }, "Add Category"), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(DeleteMenuItem, { onClick: onDelete })) : /* @__PURE__ */ React.createElement("div", null)
  ), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      title: "Are you sure you want to delete these assets?",
      onConfirm: onConfirmDelete,
      onCancel: () => setShowDeleteModal(false),
      showModal: showDeleteModal
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, "You are about to delete the following assets:"), selectedAssets.map((asset) => /* @__PURE__ */ React.createElement("div", { key: asset.id }, asset.name)))
  ), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      title: "Choose or create a category",
      onCancel: () => resetCategoryModalStates(),
      onConfirm: () => onConfirmAddCategories(),
      showModal: showAddCategoryModal
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, "Select category:"), /* @__PURE__ */ React.createElement(
      StyledSelect,
      {
        name: "category",
        id: "category",
        placeholder: "Add or select a category",
        multi: true,
        allowCreate: true,
        menuPlacement: "bottom",
        maxMenuHeight: 200,
        value: categoryValue ? categoryValue.toString() : null,
        onChange: (newValue) => setCategoryValue(newValue ? newValue.split(",") : []),
        onBlur: () => setCategoryValue(categoryValue),
        options: categoryOptions
      }
    ), /* @__PURE__ */ React.createElement("div", null, "The selected category/categories will be applied to the following assets:"), selectedAssets.map((asset) => /* @__PURE__ */ React.createElement("div", { key: asset.id }, asset.name)))
  ));
};
export default BulkActions;
